module.exports = {"430902005":"大码头街道","430902006":"汽车路街道","430902102":"迎风桥镇","430902104":"沙头镇","430902105":"茈湖口镇","430902106":"长春镇","430902107":"新桥河镇","430902203":"张家塞乡","430902401":"长春工业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430902.json
// module id = 1721
// module chunks = 0